import { mainSiteUrl } from '@/mocks/categories';

export default function CTASection() {
  return (
    <section className="relative overflow-hidden">
      <div className="flex flex-col lg:flex-row min-h-[420px] md:min-h-[480px]">
        <div className="lg:w-1/2 relative overflow-hidden min-h-[240px] lg:min-h-0">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20editorial%20product%20photography%20of%20curated%20fashion%20lifestyle%20items%20including%20premium%20sneakers%20a%20structured%20handbag%20and%20accessories%20arranged%20on%20a%20soft%20warm%20clay%20colored%20surface%20with%20gentle%20afternoon%20sunlight%20streaming%20through%20linen%20curtains%20creating%20a%20cozy%20sophisticated%20atmosphere%20modern%20European%20boutique%20aesthetic%20rich%20textures%20and%20harmonious%20earth%20tones&width=1000&height=700&seq=cta-product-v2&orientation=landscape"
            alt="Oopbuy Spreadsheet Produkte"
            className="absolute inset-0 w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/30 to-transparent"></div>
          <div className="absolute top-6 left-6 z-10">
            <span className="text-xs font-medium text-white/70 tracking-wider uppercase">Exklusiver Zugang</span>
          </div>
          <div className="absolute bottom-6 left-6 z-10">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-semibold text-white leading-tight">
              Jetzt<br />Oopbuy<br />Spreadsheet kaufen
            </h2>
          </div>
        </div>

        <div className="lg:w-1/2 flex items-center justify-center bg-background-100 px-6 md:px-10 py-12 lg:py-0">
          <div className="max-w-md text-center lg:text-left">
            <h3 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 leading-tight mb-4">
              Starten Sie Ihren<br />Einkauf
            </h3>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
              Entdecken Sie über 1000 Produkte im Oopbuy Spreadsheet. Mit QC-Service, transparenter Zollberechnung und Express-Versand direkt nach Deutschland. Ihr smarter Einkaufsbegleiter wartet auf Sie.
            </p>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-7 py-3.5 text-sm font-semibold rounded-lg bg-foreground-900 text-background-50 hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
            >
              Zum Shop
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}